module.exports = __webpack_public_path__ + "static/img/IMG_20160307_163709-PANO.32db7932.jpg";